export default __webpack_public_path__ + "static/media/product2.201f8ebd.jpg";